export const calculateProductStatus = (product) => {
    // Garante que os valores numéricos sejam tratados como números
    const initialQty = Number(product.initialQty) || 0;
    const soldQty = Number(product.soldQty) || 0;
    
    const balance = initialQty - soldQty;

    // Retorna 'ESGOTADO' primeiro se o saldo for zero ou menos, independentemente da data de validade.
    if (balance <= 0) return 'ESGOTADO';

    // Cria objetos Date a partir das strings para uma comparação segura
    const expiryDate = new Date(product.expiry);
    const today = new Date();
    
    // Zera as horas para comparar apenas as datas
    today.setHours(0, 0, 0, 0); 
    expiryDate.setHours(0, 0, 0, 0);

    const daysUntilExpiry = Math.ceil((expiryDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

    if (daysUntilExpiry < 0) return 'FORA DE VALIDADE';
    if (daysUntilExpiry <= 90) return 'VALIDADE PRÓXIMA';
    if (balance <= 2) return 'ESTOQUE BAIXO'; // Assume que "2" é o limite para estoque baixo
    
    return 'OK';
};